import threeD from "./3d.js";
import leaserCutting from "./leaserCutting.js";
import pcb from "./manufacturing";
import productDev from "./productDevelopment";

const data = [
  {
    slug: "3D-Printing",
    data: threeD,
  },
  {
    slug: "Laser-Cutting",
    data: leaserCutting,
  },
  {
    slug: "PCB-Manufacturing",
    data: pcb,
  },
  {
    slug: "Product-Development",
    data: productDev,
  },
];

export default data;
